import { Typography } from 'antd'
import { InfoCircle } from 'iconsax-react'

export type VariantType = 'warning' | 'info' | 'error'

export interface IButtonProps {
  info?: string
  subInfo?: string
  icon?: boolean
  iconColor?: string
  variant: VariantType
  className?: string
}

const Banner = (props: IButtonProps) => {
  const { info, iconColor, variant, icon, subInfo, className } = props

  const backgroundColor = (status: string) => {
    switch (status) {
      case 'warning':
        return 'bg-warning-100'
      case 'info':
        return 'bg-info-100'
      case 'error':
        return 'bg-danger-100'
      default:
        return 'bg-white'
    }
  }

  return (
    <div
      data-testid="banner-container"
      className={`${backgroundColor(
        variant,
      )} h-[60px] flex gap-2 items-center px-[12px] py-[8px] rounded-md ${className}`}
    >
      {icon && <InfoCircle size={24} color={iconColor} variant="Bold" data-testid="info-circle" />}
      <div className="flex flex-col ml-2">
        <Typography className="font-bold">{info}</Typography>
        <Typography>{subInfo}</Typography>
      </div>
    </div>
  )
}

export default Banner
